<template>
	<nav class="pagination-a">
		<ol @click="clickOnPage($event)">
			<li v-bind:class="page - 1 < 0 ? 'disabled' : ''" page="0">&laquo;</li>
			<li v-bind:class="page - 1 < 0 ? 'disabled' : ''" :page="parseInt(page) - 1">&lsaquo;</li>

			<li v-if="pageMax - page === 1 && pageMax > 3" class="" :page="parseInt(pageMax) - 4">{{ pageMax - 3 }}</li>

			<li v-if="pageMax === page && pageMax > 3" class="" :page="parseInt(pageMax) - 4">{{ pageMax - 3 }}</li>
			<li v-if="pageMax === page && pageMax > 3" class="" :page="parseInt(pageMax) - 3">{{ pageMax - 2 }}</li>

			<template v-for="i in range">
				<li v-bind:key="i" v-if="0 <= i && i <= pageMax" v-bind:class="i == page ? 'active' : ''" :page="i">{{ i + 1 }}</li>
			</template>

			<li v-if="page == 0 && pageMax > 3" class="" page="3">4</li>
			<li v-if="page == 0 && pageMax > 3" class="" page="4">5</li>
			<li v-if="page == 0 && pageMax === 3" class="" page="3">4</li>
			<li v-if="page == 1 && pageMax > 3" class="" page="4">5</li>

			<!-- > AND >> -->
			<li v-bind:class="pageMax < page + 1 ? 'disabled' : ''" :page="parseInt(page) + 1">&rsaquo;</li>
			<li v-bind:class="pageMax < page + 1 ? 'disabled' : ''" :page="pageMax">&raquo;</li>
		</ol>
	</nav>
</template>

<script>
export default {
	name: "pagination",
	props: {
		page: {},
		pageMax: {},
	},
	data() {
		return {
			range: {},
		};
	},
	mounted() {
		this.changePage();
	},

	methods: {
		clickOnPage(event) {
			let target = event.target;
			if (target.className !== "disabled") {
				let page = parseInt(target.getAttribute("page"));
				this.$emit("changepage", page);
			}
		},
		changePage() {
			let lowEnd = parseInt(this.page) - 2;
			let highEnd = parseInt(this.page) + 2;
			this.range = [];
			while (lowEnd <= highEnd) {
				this.range.push(lowEnd++);
			}
		},
	},
	watch: {
		page() {
			this.changePage();
		},
	},
};
</script>
